// Components/NavBar.js
import { Link } from 'react-router-dom';

import { withSession,withSessionOr} from '../components/context/CurrentUserContext';

const NavBarNoAuth = () => {
   return (
      <nav>
         <ul>

            <li>
               <Link to="/">Home</Link>
            </li>

            <li>
               <Link to="/userinfo">User details</Link>
            </li>

            
            <li>
               <Link to="/youtube/videodetails">Video details</Link>
            </li>
        


         </ul>
      </nav>
   );
};


const NavBarAuth = () => {
   return (
      <nav>
         <ul>

            <li>
               <Link to="/">Home</Link>
            </li>

            <li>
               <Link to="/userinfo">user details</Link>
            </li>

            <p>Admin</p>
            <li>
               <Link to="/admin/users"> users</Link>
            </li>


            <li>
               <Link to="/admin/system">System</Link>
            </li>




            {/* <p>MyTube</p>

            <li>
               <Link to="/mytube/search">Search</Link>
            </li>


            <li>
               <Link to="/mytube/channels">Channels</Link>
            </li>


            <li>
               <Link to="/">Videos</Link>
            </li>

            <br></br>


            <li>
               <Link to="/">Test Rest</Link>
            </li> */}
            {/*
            <li>
               <Link to="/cognito">Cognito</Link>
            </li>
            <li>
               <Link to="https://xbucket.xclouddev.net/">xbucket.xclouddev.net</Link>
            </li>
            <li>
               <Link to="/rest">Rest Auth</Link>
            </li>
            <li>
               <Link to="/bucket">Bucket</Link>
            </li>
            <li>
               <Link to="/login">Login</Link>
            </li>
   */}
         </ul>
      </nav>
   );
};

export default withSessionOr(NavBarAuth,NavBarNoAuth);